// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePrescriptionApi = class EdgePrescriptionApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param accountId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async accountPrescriptionGetByAccountId(accountId, x_program_id) {
        const _url_ = '/edge/prescription/v2/AccountPrescription/GetByAccountId/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPrescriptionGetByAccountId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2AccountPrescriptionGetByAccountIdAccountIdGetByAccountIdResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async ndcGetByCode(code, x_program_id) {
        const _url_ = '/edge/prescription/v2/Ndc/GetByCode/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling ndcGetByCode.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2NdcGetByCodeCodeGetByCodeResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param x_program_id The program id from the list of allowed program ids
     */
    async ndcGetById(id, x_program_id) {
        const _url_ = '/edge/prescription/v2/Ndc/GetById/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling ndcGetById.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2NdcGetByIdIdGetByIdResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async programNdcGetByProgramId(programId, x_program_id) {
        const _url_ = '/edge/prescription/v2/ProgramNdc/GetByProgramId/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programNdcGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse");
        }
        return response;
    }
};
EdgePrescriptionApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePrescriptionApi);
export { EdgePrescriptionApi };
//# sourceMappingURL=edgePrescriptionApi.js.map